export function getAdminSection() {
  if (typeof window === "undefined") return "subscribers";

  const params = new URLSearchParams(window.location.search);
  const tab = params.get("tab");
  const section = params.get("section") || "subscribers";

  if (tab === "tools" && section === "preview") return "preview";
  if (tab === "tools" && section === "campaigns") return "campaigns";
  if (section === "preview") return "preview";
  if (section === "campaigns") return "campaigns";
  if (section === "orders") return "orders";
  if (section === "bookings") return "bookings";
  if (section === "shop") return "shop";
  if (section === "products") return "products";
  if (section === "settings") return "settings";

  return "subscribers";
}

export function getAdminSectionUrl(section) {
  if (section === "preview") return "/blpkmz?tab=tools&section=preview";
  if (section === "campaigns") return "/blpkmz?tab=tools&section=campaigns";
  if (section === "orders") return "/blpkmz?section=orders";
  if (section === "bookings") return "/blpkmz?section=bookings";
  if (section === "shop") return "/blpkmz?section=shop";
  if (section === "products") return "/blpkmz?section=products";
  if (section === "settings") return "/blpkmz?section=settings";
  return "/blpkmz";
}

export function navigateAdminSection(section) {
  const url = getAdminSectionUrl(section);
  window.history.pushState({}, "", url);
  window.dispatchEvent(new PopStateEvent("popstate"));
}
